import React, { useState } from 'react';
import { Stepper } from '@operations/shared';
import SelectUserORCompany from '../createEarlyPayment/selectUserOrCompany';
import SubmitAddCollection from "./submitAddCollection"
export const ViewCollection: React.FC = () => {
    const [isCompany, setIsCompany] = useState<boolean>(true);
    const [identifier, setIdentifier] = useState<any>(null);
    
    console.log(identifier)
    const componentSteps = [
        {
            title: 'Who Paid',
            content: (
                <SelectUserORCompany
                    isCompany={isCompany}
                    setIsCompany={setIsCompany}
                    setIdentifier={setIdentifier}
                    isUnidentified={false}
                />
            ),
            id: 0,
        },
        {
            title: 'Submit Collection',
            content: <SubmitAddCollection isCompany={isCompany} identifier={identifier} />,
            id: 1,
        },
    ];


    return (
        <>
            <Stepper componentSteps={componentSteps} />
        </>
    );
};

